import { CardWithIcon } from '../../Design/Cards'

import PersonAddIcon from '@mui/icons-material/PersonAdd'
import CircularProgress from '@mui/material/CircularProgress'

const LeadsInscrits = ({ value, mepCount, loading }) => (
  <div>
    <CardWithIcon
      to="/leads"
      icon={PersonAddIcon}
      title="Contacts inscrits"
      subtitle={loading ? <CircularProgress size="15px" /> : value}
      caption={!loading && mepCount > 0 ? `dont ${mepCount} récupérés depuis MEP` : undefined}
      color="#51cc5d"
    />
  </div>
)

export default LeadsInscrits